import { createFileRoute } from "@tanstack/react-router";
import { PaginaRota } from "@/paginas/pg_database/database-exportacao";

export const Route = createFileRoute("/_authenticated/database-exportacao")({
  head: () => ({
    meta: [
      { title: "Banco de dados — Milky Moo Palmares" },
      {
        name: "description",
        content: "Exportação e download da base de dados e planilhas de produtos/insumos.",
      },
      { property: "og:title", content: "Banco de dados — Milky Moo Palmares" },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: PaginaRota,
});
